import {h5ObtainProfile} from '@library/hybrid';
import {JSBridgePipeline, BlockItem, Profile} from '@library/JSBridgeFunction/utils';

class GetProfile {
    private static readonly STORAGE_KEY = 'ACTIVITY_PROFILE';
    private pipeline = new JSBridgePipeline<Profile | undefined>(GetProfile.name);

    private fnErrorHandler(error: any): void {
        // 只收集端内打开报错。为了避免后续 catch 收集 error 通过异步让 sentry 收集。
        if (/MICO/i.test(navigator.userAgent)) {
            setTimeout(() => {
                if(error instanceof Error) {
                    throw error;
                }
                else {
                    throw new Error(`GetProfile h5ObtainProfile 错误：${JSON.stringify(error)}`);
                }
            });
        }
    }
    private async fnCallAppBridgeApi(task: BlockItem<Profile | undefined>): Promise<Profile | undefined> {
        let profile: Profile | undefined;
        try {
            const userProfile = await h5ObtainProfile() as Profile;
            if (userProfile) {
                profile = userProfile;
                // 成功获取 profile 并会话级缓存。
                //? 不使用内存变量缓存是因为运营位 webview 复用可保存 sessionStorage 数据。
                window.sessionStorage.setItem(GetProfile.STORAGE_KEY, JSON.stringify(profile));
                // 释放所有 pipeline 中的 task
                this.pipeline.fnResolveTask(profile, task);
            }
        } catch (error) {
            // 获取失败后只释放当前请求的 promise
            this.pipeline.fnResolveTask(undefined, task);
            this.fnErrorHandler(error);
        }
        return profile;
    }
    async fnGetProfile(): Promise<Profile | undefined> {
        // 优先检查会话缓存
        const cachedProfile = window.sessionStorage.getItem(GetProfile.STORAGE_KEY);
        if (cachedProfile) return JSON.parse(cachedProfile);
        // 管道中任务正常返回 JSBridge API 数据，则直接使用
        const {result, task: currentTask} = await this.pipeline.fnExecuteTask();
        if(result) return result;
        // 以上逻辑获取数据失败，则发起新的任务
        const profile = await this.fnCallAppBridgeApi(currentTask);
        return profile;
    }
}

const instance = new GetProfile();
export default instance.fnGetProfile.bind(instance);